import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
// language list
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LayoutConfigService, SplashScreenService, TranslationService } from '@core/_base/layout';
import { locale as chLang } from '@core/_config/i18n/ch';
import { locale as deLang } from '@core/_config/i18n/de';
import { locale as enLang } from '@core/_config/i18n/en';
import { locale as esLang } from '@core/_config/i18n/es';
import { locale as frLang } from '@core/_config/i18n/fr';
import { locale as jpLang } from '@core/_config/i18n/jp';

import { LayoutConfig } from '@core/_config/layout.config';
import { SwUpdateNotifierService } from '@utils/services/sw-update-notifier.service';
import { environment } from 'environments/environment';
import { filter, map } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
	loader = true;
	private readonly _subscription = new Subscription();

	constructor(
		private readonly titleService: Title,
		private readonly activatedRoute: ActivatedRoute,
		private readonly translationService: TranslationService,
		private readonly router: Router,
		private readonly layoutConfigService: LayoutConfigService,
		private readonly splashScreenService: SplashScreenService,
		private readonly _swUpdateNotifierService: SwUpdateNotifierService,
		private readonly _swUpdate: SwUpdate
	) {
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);

		this._subscription.add(
			this.router.events
				.pipe(
					filter((event) => event instanceof NavigationEnd),
					map(() => {
						let child = this.activatedRoute.firstChild;
						while (child) {
							if (child.firstChild) {
								child = child.firstChild;
							} else if (child?.snapshot?.data['title']) {
								return child.snapshot.data['title'] as string;
							} else {
								return null;
							}
						}
						return null;
					})
				)
				.subscribe((data) => {
					if (data) {
						this.titleService.setTitle(`${String(data)} | Documentos operativos`);
					}
				})
		);
	}

	private _title(): string {
		const title = environment.PATH_BASE;
		return `${title[0].toLocaleUpperCase()}${title.slice(1, title.length)}`;
	}

	ngOnInit(): void {
		this._swUpdateNotifierService.init();
		this._handleUnrecoverableState();
		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);
		this.loader = Boolean(this.layoutConfigService.getConfig('loader.enabled'));

		this._subscription.add(
			this.router.events.subscribe((event) => {
				if (event instanceof NavigationEnd) {
					this.splashScreenService.hide();
					document.body.classList.add('kt-page--loaded');
					window.scrollTo(0, 0);
				}
			})
		);
	}

	ngOnDestroy(): void {
		this._subscription.unsubscribe();
	}

	private _handleUnrecoverableState(): void {
		this._swUpdate.unrecoverable.subscribe((event) => {
			console.error('Unrecoverable state:', event.reason);

			// Notify user and reload
			if (confirm('An error occurred that requires reloading the page. Reload now?')) {
				window.location.reload();
			}
		});
	}
}
